import React from 'react';
import ReactDOM from 'react-dom';
import SuccessStory from './src/SuccessStory';

window.Drupal.behaviors['successStoryApplication'] = {
    attach(context: Document | HTMLElement, settings: DrupalSettings) {
        context.querySelectorAll<HTMLDivElement>('[data-success-story-application]').forEach((el) => {
            if (el.dataset['successStoryApplicationInitialized']) return;
            el.dataset['successStoryApplicationInitialized'] = 'true';

            const script = el.querySelector('script');
            if (!script) return;

            const data = JSON.parse(script.innerHTML);
            if (!data) return;

            ReactDOM.render(React.createElement(SuccessStory, { data }), el);
        });
    },
};
